import { useState } from "react";

// The occasion planner's two choices: which occasion, which reward. The
// message and "when it is sent" copy are derived from them.
export function useOccasionPlanner(initialOccasion: string, initialReward: string) {
  const initialState = { occasion: initialOccasion, reward: initialReward };
  const [state, setState] = useState(initialState);

  const setOccasion = (occasion: string) =>
    setState((state) => ({ ...state, occasion }));
  const setReward = (reward: string) => setState((state) => ({ ...state, reward }));

  return { ...state, setOccasion, setReward };
}
